<template>
  <!-- Main container with relative positioning and fixed height -->
  <div class="relative w-full h-screen overflow-hidden flex items-center justify-center text-center text-white">

    <!-- The video element with muted, autoplaying, and looping attributes -->
    <video
        class="absolute top-0 left-0 w-full h-full object-cover"
        autoplay
        loop
        muted
        playsinline
        :src="videoUrl">
    </video>

    <!-- Vignette overlay using a pseudo-element -->
    <div class="absolute inset-0 bg-black opacity-40"></div>
    <div class="absolute inset-0 z-10" style="
      background: radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.8) 100%);
    "></div>

    <!-- Content overlay -->
    <div class="relative z-20 p-4 md:p-8">
      <!-- Title -->
      <h1 class="text-3xl md:text-6xl font-bold leading-tight drop-shadow-lg mb-6">
        RITA LIMÃO
      </h1>
      <!-- Call to Action Button -->
      <button class="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-colors duration-200 uppercase tracking-wide">
        PORTFOLIO
      </button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
    };
  }
};
</script>

<style scoped>
/* Scoped styles for this component */
.font-sans {
  font-family: 'Inter', sans-serif;
}
</style>